/**
 * The band of a BI dashboard (CU-869fmhmx8 E7, UX "Regla de maquetación", Curro v3): five fields, Office · Rental
 * length · Cars · Pick-up dates · Prices captured. One row from 1100 px of window with proportional widths; below, 3
 * + 2, never a field alone. Each row is its own grid (`gridTemplateColumns`) with the same weights inside.
 *
 * Pure and alias-free: `node --test` runs it.
 */

export const BAND_KEYS = Object.freeze(['office', 'lor', 'cars', 'pickup', 'captured'])
export const BAND_WEIGHTS = Object.freeze({ office: 1.3, lor: 0.7, cars: 1.35, pickup: 1.25, captured: 0.85 })
export const BAND_ONE_ROW_MIN = 1100
export const BAND_ONE_ROW_QUERY = `(min-width:${BAND_ONE_ROW_MIN}px)`

const SPLIT = Object.freeze([['office', 'lor', 'cars'], ['pickup', 'captured']])

/**
 * `{ rows: [[key…]…], columns: ['<grid-template-columns>' per row] }` for a window width. `extraRow` (CU-869fmjzrg,
 * "Week by week"): a second row of fields under the five, equal widths, so no field is ever alone.
 */
export function bandLayout(windowWidth, { extraRow = null } = {}) {
	const rows = windowWidth >= BAND_ONE_ROW_MIN ? [[...BAND_KEYS]] : SPLIT.map(r => [...r])
	const columns = rows.map(r => r.map(k => `${BAND_WEIGHTS[k]}fr`).join(' '))
	if (extraRow?.length) {
		rows.push([...extraRow])
		columns.push(extraRow.map(() => '1fr').join(' '))
	}
	return { rows, columns }
}
